export enum InterceptionProcessEnum {
    Clients = "[InterceptClientAccountData]",
    Event = "[InterceptEventData]",
    Exchange = "[InterceptExchangeData]",
    GenericInstrumentMappings = "[InterceptGenericInstrumentMappings]",
    Instrument = "[InterceptInstrumentData]",
}